
import u from "umbrellajs"
import _once from "lodash/once"
import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

import MobileApps_SearcherApp_DownloadLink from "concepts/mobile_apps/searcher_app/download_link/index"

// Mobile footer wechat QRcode popover
const $body = u("body")

const CLASS_NAMES = {
  WECHAT_POPUP_SHOWN: "main-footer--wechat-popup-shown",
}

const getFooterElement = _once(() => u(".main-footer"))
const getPopupElement = () => u(".main-footer__wechat-id-popup")
const getShowPopupButton = () => u("#main-footer__btn-show-wechat-popup")



const showWechatPopup = () => {
  getFooterElement().addClass(CLASS_NAMES.WECHAT_POPUP_SHOWN)
  // # add click event handler
  $body.on("click", CLICK_EVENT_HANDLER_FOR_HIDING_WECHAT_POPUP)
}

const hideWechatPopup = () => {
  $body.off("click", CLICK_EVENT_HANDLER_FOR_HIDING_WECHAT_POPUP)
  getFooterElement().removeClass(CLASS_NAMES.WECHAT_POPUP_SHOWN)
}

const toggleWechatPopup = () => {
  if (getFooterElement().hasClass(CLASS_NAMES.WECHAT_POPUP_SHOWN)) {
    hideWechatPopup()
  }
  else {
    showWechatPopup()
  }
}

function CLICK_EVENT_HANDLER_FOR_HIDING_WECHAT_POPUP(e: Event) {
  const $container = getPopupElement()
  const $button = getShowPopupButton()
  // # Since this handler is fired right after being added
  // # This is a workaround
  const event_target = e.target as HTMLElement

  if (event_target == null) { return }

  const button_contains_event_target = $button.is((el) => {
    if (el === event_target) { return true }

    const children = el.getElementsByTagName("*")
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < children.length; i++) {
      if (children[i] === event_target) { return true }
    }

    return false
  })
  if (button_contains_event_target) { return }

  // # Prevent closing it when clicked inside
  const container_contains_event_target = $container.is((el) => {
    if (el === event_target) { return true }

    const children = el.getElementsByTagName("*")
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < children.length; i++) {
      if (children[i] === event_target) { return true }
    }

    return false
  })
  if (container_contains_event_target) { return }

  hideWechatPopup()
  e.preventDefault()
  e.stopPropagation()
}

const onLoad = () => {
  requestIdleCallback(() => {
    getShowPopupButton().on("click", () => {
      toggleWechatPopup()
    })

    MobileApps_SearcherApp_DownloadLink.init()
  })
}

export default {onLoad}

